import { Controller } from "@hotwired/stimulus"

// Tracks AI summary impressions and link clicks
// Usage:
//   data-controller="ai-summary-tracking"
//   data-ai-summary-tracking-summary-id-value="123"
//   data-ai-summary-tracking-website-id-value="456"
export default class extends Controller {
  static values = {
    summaryId: Number,
    websiteId: Number
  }

  connect() {
    // Track that the AI summary card was shown
    this.trackImpression()

    // Listen for link clicks within the element
    this.element.addEventListener("click", this.handleClick.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("click", this.handleClick.bind(this))
  }

  trackImpression() {
    this.dispatch("impression", {
      detail: {
        summaryId: this.summaryIdValue,
        websiteId: this.websiteIdValue,
        timestamp: new Date().toISOString()
      }
    })

    // Also track via Ahoy if available
    if (typeof ahoy !== "undefined") {
      ahoy.track("ai_summary_impression", {
        summary_id: this.summaryIdValue,
        website_id: this.websiteIdValue
      })
    }
  }

  handleClick(event) {
    const link = event.target.closest("a")
    if (!link) return

    const href = link.getAttribute("href")
    if (!href) return

    // Fire custom event for link click (doesn't block navigation)
    this.dispatch("linkClick", {
      detail: {
        summaryId: this.summaryIdValue,
        websiteId: this.websiteIdValue,
        href: href,
        linkText: link.textContent?.trim(),
        timestamp: new Date().toISOString()
      }
    })

    // Also track via Ahoy if available
    if (typeof ahoy !== "undefined") {
      ahoy.track("ai_summary_link_click", {
        summary_id: this.summaryIdValue,
        website_id: this.websiteIdValue,
        href: href,
        link_text: link.textContent?.trim()
      })
    }
  }
}
